import { initAnalytics, StateAnalyticsParams } from './analytics/analytics';
import { updateGdprApplies } from './init.utils';
import { markPerformance } from './performance';
import { ErrorReporter } from './errorReporter.type';

export type CoreParams = StateAnalyticsParams;

export function init(params: CoreParams, errorProvider: ErrorReporter) {
  try {
    initAnalytics(params);
    markPerformance('init-analytics');
  } catch (e) {
    errorProvider.reportException(e);
  }
  try {
    updateGdprApplies();
  } catch (e) {
    errorProvider.reportException(e);
  }
}
